module.exports = __webpack_public_path__ + "static/media/banner_tablet.8503ff0e.png";